import React, { FC } from 'react';
import cns from 'classnames';

import styles from './DetailsRow.module.scss';

interface Props {
  title: string,
  value?: any,
  className?: string,
}

export const DetailsRow: FC<Props> = ({ title, value, className }) => {
  return (
    <div className={cns(styles.wrapper, className)}>
      <div className={styles.title}>{title}</div>
      <div className={styles.value}>{value}</div>
    </div>
  );
};
